import React, { useEffect, useState } from "react";
import {
  PencilIcon,
  TrashIcon,
  EyeIcon,
  DocumentDuplicateIcon,
} from "@heroicons/react/24/outline";
import { useNCallContext } from "../../context/ncall-context";
import Table from "../../components/table";
import NoData from "../../components/noData";
import { useNavigate } from "react-router-dom";
import { API } from "../../service/api";
import { showErrorToast, showSuccessToast } from "../../utils/toast";
import ConfirmationModal from "../../components/modal/confirmationModal";
import { useRef } from "react";

const Reports = () => {
  const { state, dispatch, getReports } = useNCallContext();
  const confirmationmodalRef = useRef(null);

  const { reports } = state;

  const navigate = useNavigate();

  // const getReports = async () => {
  //   let _clientId = localStorage.getItem("companyId");

  //   if (_clientId) {
  //     try {
  //       const reports = await API.getAllReports();
  //       dispatch({ type: "ADD-REPORTS", payload: { reports: reports.data } });
  //     } catch (error) {
  //       showErrorToast(error);
  //     }
  //   } else {
  //     return;
  //   }
  // };

  const viewHandler = async (report) => {
    let data = {};

    try {
      const _report = await API.getReport(report.id, {
        report_url: report.report_url,
        report_source: report.report_source,
      });

      // if (report.report_source === "calls") {
      data["rows"] = _report?.data;

      data["columns"] = JSON.parse(report.output_feilds);
      data["info"] = {
        heading: report.report_heading,
        name: report.report_name,
        subheading: report.report_subheading,
        footer: report.report_footer,
      };
      data["sortBy"] = report.sortBy;
      data["orderBy"] = report.orderBy;
      // }

      navigate("/admin/client-detail/reports/view-report", {
        state: { data },
      });
    } catch (error) {
      showErrorToast(error);
    }
  };
  const updateHandler = (report) => {
    navigate("/admin/client-detail/reports/edit-report", { state: { report } });
  };

  const openDeletionConfirmationModal = (report) => {
    if (confirmationmodalRef) {
      confirmationmodalRef.current.handleModalOpen();
      confirmationmodalRef.current.setRecordForModal(report);
      confirmationmodalRef.current.setHandlerMethod(() => deleteHandler);
    }
  };

  const deleteHandler = async (report) => {
    try {
      const res = await API.deleteReport(report.id);

      if (res.error) {
        showErrorToast(res.message);
      } else {
        showSuccessToast(res.message);
        getReports();
      }
    } catch (error) {
      showErrorToast(error);
    }
  };

  const openDuplicateConfirmationModal = (report) => {
    if (confirmationmodalRef) {
      confirmationmodalRef.current.handleModalOpen();
      confirmationmodalRef.current.setRecordForModal(report);
      confirmationmodalRef.current.setHandlerMethod(() => duplicateHandler);
    }
  };

  const duplicateHandler = async (report) => {
    const {
      company_id,
      orderBy,
      output_feilds,
      report_filters,
      report_footer,
      report_heading,
      report_name,
      report_source,
      report_subheading,
      report_url,
      sortBy,
    } = report;

    const duplicatedReport = {
      report_name: `${report_name} - Copy`,
      report_heading: report_heading,
      report_subheading: report_subheading,
      report_filters: report_filters,
      company_id: company_id,
      output_feilds: output_feilds,
      sortBy: sortBy,
      orderBy: orderBy,
      report_url: report_url,
      report_footer: report_footer,
      report_source: report_source,
    };

    try {
      const res = await API.postReport(duplicatedReport);

      if (res.error) {
        showErrorToast(res.message);
      } else {
        showSuccessToast(res.message);
        getReports();
      }
    } catch (error) {
      showErrorToast(error);
    }
  };

  useEffect(() => {
    getReports();
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "report_name",
      },
      {
        Header: "Heading",
        accessor: "report_heading",
      },
      {
        Header: "Sub-Heading",
        accessor: "report_subheading",
      },
      {
        Header: "Source",
        accessor: "report_source",
      },
      {
        Header: "Output Feilds",
        accessor: "output_feilds",
        Cell: ({ value }) => {
          const outputFields = JSON.parse(value);
          return (
            <div className=" max-h-28 overflow-auto flex justify-start items-start flex-wrap">
              {outputFields.map((field, index) => (
                <div
                  className="bg-slate-200 p-1 m-1 text-xs rounded-sm "
                  key={index}
                >
                  {field.value}
                </div>
              ))}
            </div>
          );
        },
      },
      {
        Header: "Filters",
        accessor: "report_filters",
        Cell: ({ value }) => {
          const filters = JSON.parse(value);
          return (
            <div className=" max-h-28 overflow-auto flex justify-start items-start flex-wrap">
              {filters.map((filter, index) => (
                <span
                  className=" bg-gray-200 p-1 m-1 text-xs rounded-sm"
                  key={index}
                >
                  {filter.value}
                </span>
              ))}
            </div>
          );
        },
      },
      {
        Header: "Footer",
        accessor: "report_footer",
      },
      {
        Header: "Sort By",
        accessor: "sortBy",
      },
      {
        Header: "Order By",
        accessor: "orderBy",
      },
    ],
    []
  );

  useEffect(() => {
    localStorage.setItem(
      "sort",
      JSON.stringify({ id: "report_name", desc: false })
    );
  });

  const actions = [
    {
      icon: EyeIcon,
      handler: viewHandler,
      styles: "text-indigo-500 w-5 h-5  inline",
    },
    {
      icon: DocumentDuplicateIcon,
      handler: openDuplicateConfirmationModal,
      styles: "text-indigo-500 w-5 h-5  inline",
    },
    {
      icon: PencilIcon,
      handler: updateHandler,
      styles: "w-5 h-5 text-green-500",
    },
    {
      icon: TrashIcon,
      handler: openDeletionConfirmationModal,
      styles: "w-5 h-5 text-red-500",
    },
  ];

  return (
    <div>
      {<ConfirmationModal ref={confirmationmodalRef} />}

      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Reports
          </h1>
        </div>
        <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
          <button
            onClick={() => {
              navigate("/admin/client-detail/reports/new-report");
            }}
            type="button"
            className="block rounded-md bg-indigo-600 py-2 px-3 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            New Report
          </button>
        </div>
      </div>
      {reports.length === 0 ? (
        <NoData message={"You don't have any reports."} />
      ) : (
        <div className="mt-8 flow-root">
          <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <Table
                columns={columns}
                data={reports}
                actions={actions}
                name="reports"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Reports;
